<template>
    <BreadCrumb PageTitle="Ajouter un BL" />
    <AddBlStep2 />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddBlStep2 from "@/components/BESC/AddBesc/AddBlStep2.vue";
  
    export default defineComponent({
      name: "AddBlStep2Page",
      components: {
        BreadCrumb,
        AddBlStep2,
      },
    });
  </script>